<template>
  <div>
    <Layout>
      <Header>
        <h2 id="title">後台系統 - BACKEND SYSTEM</h2>
      </Header>
      <Row>
        <Col
          span="24"
          align="middle"
          class="mt-4"
        >
        <Col span="24">
        <h1>{{companyname}} tianzun</h1>
        </Col>
        <Col span="24">
        <Form
          ref="formInline"
          :model="formdata"
          :rules="ruleInline"
          style="width: 300px"
          :label-width="80"
          hide-required-mark
          class="pr-3 pt-3"
        >
          <FormItem
            prop="uname"
            label="帐号："
          >
            <Input
              type="text"
              v-model="formdata.uname"
              @on-enter.prevent="handleSubmit('formInline')"
              placeholder="请输入帐号"
            ></Input>
          </FormItem>
          <FormItem
            prop="upass"
            label="密码："
          >
            <Input
              type="password"
              password
              v-model="formdata.upass"
              @on-enter.prevent="handleSubmit('formInline')"
              placeholder="请输入密码"
            ></Input>
          </FormItem>
          <FormItem
            prop="infocode"
            label="验证码："
          >
            <Row
              type="flex"
              align="middle"
            >
              <Col style="flex: 0 0 auto">
              <Input
                style="width: 120px; margin-right: 10px"
                v-model="formdata.infocode"
                placeholder="验证码"
                @on-enter="handleSubmit('formInline')"
              />
              </Col>
              <Col style="flex: 1 1 70px">
              <identify
                @click.native="createcode"
                backgroundColor="#fff"
                :identifyCode="vercodetext"
                :contentHeight="30"
                :contentWidth="70"
              ></identify>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Button
              type="primary"
              @click="handleSubmit('formInline')"
            >登入</Button>
          </FormItem>
        </Form>
        </Col>
        </Col>
      </Row>
      <br />
      <Footer align="middle">
        <Copyright />
      </Footer>
    </Layout>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Identify from '@/components/common/Identify'
import allGameJs from '@/mixins/get-all-game.js'
export default {
  name: 'login',
  mixins: [allGameJs],
  components: {
    Identify
  },
  data () {
    const checkinfocode = (rule, value, callback) => {
      const self = this
      if (value == self.vercodetext) {
        callback();
      } else {
        callback(new Error('验证码输入错误'));
      }
    }
    return {
      vercodetext: '',
      companyname: "",
      formdata: {
        uname: "",
        upass: "",
        add: "",
        infocode: ''
      },
      ruleInline: {
        uname: [{ required: true, message: "帐号请勿留空", trigger: "blur" }],
        upass: [{ required: true, message: "密码请勿留空", trigger: "blur" }],
        infocode: [
          { required: true, message: '验证码请勿留空', trigger: 'blur' },
          { validator: checkinfocode, trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(['getAllGame'])
  },
  async created () {
    try {
      // const country = await this.$axios.country()
      // this.formdata.add = country.country + country.city
      const res = await this.$axios.companyname()
      if ('status' in res && res.status === 0) return
      this.companyname = res[0].companyname;
      if (process.env.NODE_ENV == 'development') {
        this.formdata.uname = ''
        this.formdata.upass = ''
      }
    } catch (error) {
      console.error(error)
    }
  },
  mounted () {
    this.createcode()
  },
  methods: {
    ...mapActions(["setlogindata", "setGameclass"]),
    createcode () { // 亂碼funciton
      this.vercodetext = ''
      let code = ''
      let codelength = 4
      let random = "abcdefghijklmnopqrstuvwxyz123456789"
      for (let i = 0; i < codelength; i++) {
        let index = Math.floor(Math.random() * random.length);
        code += random.split('')[index];
      }
      this.vercodetext = code
    },
    async postData () {
      try {
        const data = await this.$axios.login(this.formdata);
        if (data.status == 1) {
          this.$Spin.hide();
          await this.setlogindata(data);
          await this.getAllGameList()
          await this.getpmtgeList()
          let gamelist = this.getAllGame.filter(item => [1, 14, 15, 78, 201, 210, 212, 213, 224, 225, 226, 227, 228, 229].includes(item.gameid))
          this.setGameclass(gamelist[0].gameid)
          this.$router.push({ name: "main", params: { GD: gamelist[0].gameid } }).catch(err => {
            console.log(err)
          })
        } else {
          this.clearData()
          this.$Spin.hide();
        }
      } catch (error) {
        this.$Spin.hide();
        console.log(error);
        this.clearData()
        this.$Message.error("请确认网路是否连线正常");
      }
    },
    clearData () {
      this.formdata.upass = ''
      this.formdata.infocode = ''
      this.createcode()
    },
    handleSubmit (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.postData()
        }
      });
    },
    SpinShow () {
      this.$Spin.show({
        render: h => {
          return h("div", [
            h("Icon", {
              class: "demo-spin-icon-load",
              props: {
                type: "ios-loading",
                size: 90
              }
            }),
            h(
              "div",
              {
                class: "title mt-2"
              },
              "登入中..."
            )
          ]);
        }
      });
    }
  }
};
</script>
<style scoped>
#title {
  color: aliceblue;
}
</style>